import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import AuthRoutes from './authRoutes';
import AdminRoutes from './adminRoutes';
import Dashboard from '../dashboard';
import {
    set_current_route,
    set_current_route_array,
    set_is_mobile_sidebar,
  } from '../../core/data/redux/action';
  
  import {
    AppState,
    CurrentRoute,
    Pageinfos,
    ProviderEarningsadmindatas,
  } from '../../core/models/interface';
  import { useNavigate } from 'react-router-dom';
import NotFound from '../../feature-module/components/not-found';
import PartnerRoutes from './partnerRoutes';
import ProjectRoutes from './projectRoutes';
import LeadRoutes from './leadRoutes';
import ProposalRoutes from './proposalRoutes';
    
const AllRoutes = () => {
    const navigate = useNavigate();
    const toggle_data = useSelector(
        (state: ProviderEarningsadmindatas) => state.ProviderEarningsAdmin,
      );
    const toggle_data_2 = useSelector((state: AppState) => state.toggleSidebar2);
    const mouse_data = useSelector((state: AppState) => state.mouseOverSidebar);

    const location = useLocation();
    const [currentRoute, setCurrentRoute] = useState(location.pathname);
    const current_route = useSelector((state: Pageinfos) => state.current_route);
    const mobileSidebar = useSelector((state: AppState) => state.mobileSidebar);

    const current_route_array = useSelector(
    (state: CurrentRoute) => state.current_route_array,
    );
    const dispatch = useDispatch();
    const getRoutes = () => {
        setCurrentRoute(location.pathname);
        const splitVal = location.pathname.split('/');
        const route_data = {
            base: splitVal[1],
            page: splitVal[2] || '',
            last: splitVal[3] || '',
        };
        dispatch(set_current_route_array(splitVal));
        dispatch(set_current_route(route_data));
        dispatch(set_is_mobile_sidebar(false));
    };

    useEffect(() => {
        getRoutes();
    }, [location.pathname, currentRoute]);

    useEffect(() => {
        const userData = localStorage.getItem('userData');
        if (!userData && !location.pathname.includes('auth')) {
            navigate('/auth/login');
        }
    }, []);

      

  return (
    <div
      className={`${location.pathname.startsWith('/providers') ? 'provider-body' : ''}${
        location.pathname.startsWith('/authentication') ? 'login-body' : ''
      }${location.pathname.startsWith('/admin') ? 'admin' : ''} ${
        toggle_data_2 ? 'mini-sidebar' : ''
      } ${mobileSidebar ? 'menu-opened slide-nav' : ''} ${
        mouse_data ? 'expand-menu' : ''
      } ${location.pathname.startsWith('/home-five') ? 'home-page-five' : ''}`}
    >
        <div className={`main-wrapper ${mobileSidebar ? 'menu-opened' : ''}`}>
            <Routes>
                <Route path="/auth/*" element={<AuthRoutes />} />
                <Route path="/admin/*" element={<AdminRoutes />} />
                <Route path="/partners/*" element={<PartnerRoutes />} />
                <Route path="/projects/*" element={<ProjectRoutes />} />
                <Route path="/leads/*" element={<LeadRoutes />} />
                <Route path="/proposals/*" element={<ProposalRoutes />} />
                {/* <Route path="/customers/*" element={<CustomerRoutes />} /> */}
                {/* <Route path="/finance/*" element={<FinanceRoutes />} /> */}
                <Route path="/" element={<Dashboard />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </div>

        <div
        className={`sidebar-overlay ${toggle_data ? 'opened' : ''} ${
          mobileSidebar ? 'opened' : ''
        }`}
      ></div>
        
    </div>
  );
};

export default AllRoutes;
